import React from 'react';
import { Route, Switch } from 'react-router-dom';
/* 
  Import before Main so particular styles defined in components have
  more importance than the ones defined in bootstrap
 */
import 'styles/custom-bootstrap.scss';
import { OTHER_ROUTES } from 'utils/routes';
import AccessControlUtils from 'utils/access-control';
import ReactGA from 'react-ga';
import { AuthApp, SSOConfiguration } from '@spins/react-sso-provider';
import { initializeHotjar } from 'utils/tracking';
import AppInit from 'containers/AccessControl';

const ssoConfiguration: SSOConfiguration = {
  BearerGrant: process.env.REACT_APP_BEARER_GRANT,
  SsoUrl: process.env.REACT_APP_AUTH_API_URL,
  SsoClientId: 'd-signals'
};

const App: React.FC = () => {
  ReactGA.initialize(process.env.REACT_APP_GA_ID, { redactEmail: false });
  initializeHotjar();

  return (
    <AuthApp appId="signals" ssoConfiguration={ssoConfiguration}>
      <Switch>
        <Route
          exact
          path={OTHER_ROUTES.LOGOUT}
          component={() => {
            // @ts-ignore
            window.location = AccessControlUtils.getCmsLogoutUrl();
            return null;
          }}
        />
        <Route
          exact
          path={OTHER_ROUTES.CHANGE_BRAND}
          component={() => {
            // @ts-ignore
            window.location = AccessControlUtils.getChangeBrandUrl();
            return null;
          }}
        />
        <Route
          exact
          path={OTHER_ROUTES.REDIRECT_CMS_LOGIN}
          component={() => {
            // @ts-ignore
            window.location = AccessControlUtils.getCmsLoginUrl();
            return null;
          }}
        />
        <Route component={AppInit} />
      </Switch>
    </AuthApp>
  );
};

export default App;
